import { Text, TextProps, styles, useTooltip } from '@frontend/design-system';

interface Props extends TextProps {
  text?: string;
  tooltipLabel?: string;
  hideTooltip?: boolean;
}

export const TruncatedText = ({ children, text = '', tooltipLabel = '', hideTooltip = false, ...rest }: Props) => {
  const { Tooltip, triggerProps, tooltipProps } = useTooltip();

  return (
    <>
      <Text css={[styles.truncate, { flex: 'unset' }]} {...triggerProps} {...rest}>
        {children || text}
      </Text>
      {!hideTooltip && <Tooltip {...tooltipProps}>{tooltipLabel || text}</Tooltip>}
    </>
  );
};
